var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range-inline"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('range-list',{attrs:{"items":_vm.items},on:{"select":function($event){return _vm.$emit('select', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }